import { defineComponent as _defineComponent } from 'vue'
import type { ListTitleSR, SingleTitleSR } from '@/components/sponsored-recommendations/types';
import type { SponsoredRecommendationModuleFragment } from '@/features/onboarded-home/types';

import HorizontalTitleList from '@/components/timeline/HorizontalTitleList.vue';
import SponsoredRecommendation from '@/components/sponsored-recommendations/SponsoredRecommendation.vue';

import { SraPlacement } from '@/@types/graphql-types';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { getSrPlacement, useSponsoredRec } from '@/components/sponsored-recommendations/useSendBidId';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: SponsoredRecommendationModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



useProvideClickoutPlacement('sr_home');

const sponsoredAd = computed(() => getSrPlacement(`${SraPlacement.Home}-VIEW_HOME_USER`));
const { isShadowCampaign, sponsoredAdType } = useSponsoredRec({ sponsoredAd });

const fullWidthAdTypes = ['TITLELIST', 'PREMIUM_IMAGE', 'PREMIUM_VIDEO'];

const isFullWidthCampaign = computed(() => {
	if (!sponsoredAd.value) return false;
	if (sponsoredAdType.value == null) return false;

	return fullWidthAdTypes.includes(sponsoredAdType.value);
});

const isPremiumCampaignAd = computed(() => sponsoredAdType.value?.includes('PREMIUM'));

/* TRACKING */
const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	// due to SR module wrapping, and SRs being client only, category must be set here
	moduleData: () => ({ ...props.moduleData, category: 'sponsored_recommendation' }),
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
});

function trackSRTitleClicked(title: ListTitleSR | SingleTitleSR, index: number | undefined) {
	const objectId = 'nodeId' in title ? title.nodeId : title.id;
	trackTitleClicked({ ...title, id: objectId }, { index });
}

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, sponsoredAd, isShadowCampaign, sponsoredAdType, fullWidthAdTypes, isFullWidthCampaign, isPremiumCampaignAd, moduleContext, moduleObserveVisibility, trackHomeModule, trackSRTitleClicked, trackTitleClicked, HorizontalTitleList, SponsoredRecommendation }
}

})